import React, { Component } from "react";
import PanelJsonData from "../../Json/rolesData.json";
import {
  Row,
  Col,
  Card,
  Button,
  Popover,
  Popconfirm,
  message,
} from "antd";
import RolesPermissions from "../RolesPermissions";
import { EllipsisOutlined, PlusOutlined } from "@ant-design/icons";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import Loading from "../../Common/Loading";
import ErrorView from "../../Common/ErrorView";
import SearchFunction from "../../Common/SearchFunction";
import BaseTable from "../../Common/BaseTable";
import { BsArrowLeftShort } from "react-icons/bs";
import { generatePath, withRouter } from "react-router-dom";
import { withAppContext } from "../../Store/AppContext";
import AOS from "aos";
import "aos/dist/aos.css";
import { connect } from "react-redux";
import {
  addRole,
  deleteRole,
  getRoles,
  updateRole,
} from "../../Redux/Actions/actions";
import { default as TNForm } from "../Form";
// import { newValidationSchema } from "../RolesPermissions/constants";
import { UserRoleActions } from "../../enums/UserRolesEnum";
import { appRoutes } from "../../constants/appRoutes";
import { PanelData } from "../RolesPermissions/constants";

class ManageRoles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: "",
      boardView: true,
      listView: false,
      loading: false,
      selectionType: "",
      selected: true,
      color: "active",
      isModalVisible: false,
      role: [],
      PanelInfo: {},
      options: [],
      roleName: "",
      totalRolesData: [],
      isEditModalVisible: false,
      leadsData: "",
      filterData: [],
      errorLoading: false,
      PanelData: [],
      defaultPannelsOpen: [],
      userData: "",
      SelectedPermissions: {},
    };
  }

  rolesFormRef = React.createRef();

  componentDidMount() {
    this.setState({
      PanelData: PanelJsonData["PanelData"],
      SelectedPermissions: {
        dashboard: false,
        ownerOperator: false,
        tmEdit: false,
        tmView: false,
        tmInternalApproval: false,
        cd: false,
        ood: false,
        cdd: false,
        qd: false,
        md: false,
        jd: false,
        tuEdit: false,
        tuReview: false,
        tpDataInput: false,
        tpManagerReview: false,
        tpArchiveView: false,
        tpArchiveEdit: false,
        imView: false,
        imEdit: false,
        lmView: false,
        lmEdit: false,
        paEdit: false,
        paView: false,
        btc: false,
        re: false,
        mr: false,
        su: false,
        sp: false,
        ss: false,
        rd: false,
        id: false,
      }
    });
    this.props?.actionsFetchGetRoles();
    document.title = "Twisted Nail - Manage Roles";
    AOS.init({
      // initialise with other settings
      duration: 2000,
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps?.rolesResult?.success === false &&
      this.props?.rolesResult?.success === true
    ) {
      this.setState({
        totalRolesData: this.props?.rolesResult?.rolesData,
        filterData: this.props?.rolesResult?.rolesData,
        PanelData: [],
        isModalVisible: false,
      });
    }
    if (
      prevProps?.rolesInfo?.error === false &&
      this.props?.rolesInfo?.error === true
    ) {
      message.error(
        this.props?.rolesInfo?.message || "Cannot delete this role"
      );
    }
    if (
      prevProps?.rolesInfo?.success === false &&
      this.props?.rolesInfo?.success === true
    ) {
      this.setState({
        roleLoading: false,
        PanelData: [],
        isModalVisible: false,
      });
      this.props?.actionsFetchGetRoles();
    }
    if (
      prevProps?.rolesUpdateInfo?.success === false &&
      this.props?.rolesUpdateInfo?.success === true
    ) {
      this.setState(
        {
          isEditModalVisible: false,
          roleLoading: false,
          PanelData: [],
          defaultPannelsOpen: [],
          isModalVisible: false,
        },
        () => this.props?.actionsFetchGetRoles(),
        this.props.context.getUserAccessInfo(this.state.userData?.userRoleInfo)
      );
    }
  }

  onRefresh = () => {
    this.props?.actionsFetchGetRoles();
  };

  roleName = (event) => {
    this.setState({ roleName: event.target.value });
  };

  navigateToForm = (props) => {
    let endpoint = "";
    if(props?.isEdit) {
      endpoint = generatePath(appRoutes.INTERNAL_ROLES_FORM_ID, { id: props?.id })
    } else {
      endpoint = appRoutes.INTERNAL_ROLES_FORM_ID.replace(":id", "");
    }
    this.props.history.push(endpoint, { roleData: props });
  };

  showModal = () => {
    const ToggleStatus = [UserRoleActions.ALLOW];
    const CheckData = [UserRoleActions.EDIT, UserRoleActions.VIEW];
    const TUCheckData = [UserRoleActions.EDIT, UserRoleActions.REVIEW];
    const TPCheckData = [
      UserRoleActions.DATA_INPUT,
      UserRoleActions.MANAGER_REVIEW,
      UserRoleActions.ARCHIVED_VIEW,
      UserRoleActions.ARCHIVED_EDIT,
    ];
    const TMCheckData = [
      UserRoleActions.EDIT,
      UserRoleActions.VIEW,
      UserRoleActions.INTERNAL_APPROVAL,
    ];
    const PanelData = [
      {
        key: "1",
        title: "Dashboard",
        options: ToggleStatus,
        mainPannelSelected: false,
        selectedOptions: [],
      },
      {
        key: "2",
        title: "CRM",
        mainPannelSelected: false,
        multiPannel: [
          {
            key: "21",
            title: "Trucking & Material",
            options: TMCheckData,
            selectedOptions: [],
            path: "/app/trucking-material",
          },
          {
            key: "22",
            title: "Owner Operator",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/owner-operator",
          },
        ],
        selectedOptions: false,
        options: CheckData,
      },
      {
        key: "3",
        title: "Databases",
        mainPannelSelected: false,
        multiPannel: [
          {
            key: "31",
            title: "Customer Database",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/customer-database",
          },
          {
            key: "36",
            title: "Job Database",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/job-database",
          },
          {
            key: "34",
            title: "Quarry Database",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/quarry-finder-tool",
          },
          {
            key: "35",
            title: "Material Database",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/material-database",
          },
          {
            key: "32",
            title: "Owner Operator Database",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/twisted-nail",
          },
          {
            key: "33",
            title: "CDL Driver Database",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/truck-driver-database",
          },
        ],
        selectedOptions: false,
      },
      {
        key: "4",
        mainPannelSelected: false,
        multiPannel: [
          {
            key: "41",
            options: [
              "Edit",
              "View",
              "Delete"
            ],
            path: "/app/dispatch-jobs",
            selectedOptions: ["Edit", "View", "Delete"],
            title: "Request Dispatch"
          },
          {
            key: 42,
            options: [
              "Edit",
              "View",
              "Delete"
            ],
            path: "/app/dispatch-tool",
            selectedOptions: ["Edit",
              "View",
              "Delete"],
            title: "Dispatch Tool"
          },
          {
            key: "43",
            options: [
              "Edit",
              "View",
              "Delete"
            ],
            path: "/app/dispatch-archive",
            selectedOptions: ["Edit",
              "View",
              "Delete"],
            title: "Dispatch Archive"
          }
        ],
        options: [
          "Edit",
          "View",
          "Delete"
        ],
        selectedOptions: false,
        title: "Operations",
      },
      {
        key: "5",
        title: "Finance",
        options: CheckData,
        mainPannelSelected: false,
        multiPannel: [
          {
            key: "51",
            title: "Ticket Upload",
            options: TUCheckData,
            selectedOptions: [],
            path: "/app/ticket-upload",
          },
          {
            key: "52",
            title: "Ticket Processing",
            options: TPCheckData,
            selectedOptions: [],
            path: "/app/ticket-processing",
          },
          {
            key: "53",
            title: "Invoice Management",
            options: CheckData,
            selectedOptions: [],
            path: "/app/invoiceManagement",
          },
          {
            key: "59",
            title: "Lien Process",
            options: CheckData,
            selectedOptions: [],
            path: "/app/lien-tool",
          },
          {
            key: "57",
            title: "Project Analysis",
            options: CheckData,
            selectedOptions: [],
            path: "/app/projectAnalysis",
          },
        ],
        selectedOptions: false,
      },
      {
        key: "6",
        title: "Settings",
        options: ToggleStatus,
        mainPannelSelected: false,
        multiPannel: [
          {
            key: "60",
            title: "Bid Tool Configuration",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/bid-tool-configuration",
          },
          {
            key: "61",
            title: "Rule Engine",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/rule-engine",
          },
          {
            key: "62",
            title: "Manage Roles",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/manage-roles",
          },
          {
            key: "63",
            title: "System Users",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/system-users",
          },
          {
            key: "64",
            title: "Sales People",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/salesPerson",
          },
          {
            key: "65",
            title: "System Settings",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/system-settings",
          },
          {
            key: "66",
            title: "Restore Data",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/restoreData",
          },
          {
            key: "67",
            title: "Image Database",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/imageDatabase",
          },
          {
            key: "69",
            title: "Documents",
            options: ToggleStatus,
            selectedOptions: [],
            path: "/app/documents",
          },
        ],
        selectedOptions: false,
      },
    ];

    this.setState({
      isModalVisible: true,
      leadsData: "",
      isEditModalVisible: false,
      PanelData: PanelData,
      SelectedPermissions: {},
      defaultPannelsOpen: [],
    });

    this.navigateToForm({
      isEdit: false,
      PanelData: PanelData,
    })
  };

  onResetData = () => {
    this.props?.actionsFetchGetRoles();
  };

  searchResult = (searchValue) => {;
    const { totalRolesData } = this.state;

    let searchFilter = [];
    if (typeof searchValue === "number") {
      searchFilter = totalRolesData.filter(
        (e) => parseInt(e["phone"]) === searchValue
      );
    } else {
      searchFilter = totalRolesData.filter(
        (e) => e["roleName"]?.toLowerCase().indexOf(searchValue) > -1
      );
    }

    this.setState({
      filterData: searchFilter,
    });
  };

  buildPermissions = (data) => {
    const byTitle = (title) =>
      data?.find((p) => p?.title === title);

    const child = (panelTitle,childTitle) =>
      byTitle(panelTitle)?.multiPannel?.find((m) => m?.title === childTitle);

    const selected = (node) =>
      Array.isArray(node?.selectedOptions) ? node.selectedOptions : [];

    const hasAny = (node) => selected(node).length > 0;
    const has = (node,value) => selected(node).includes(value);
    const hasAnyOf = (node,values) => values.some(v => has(node, v));
    const CONFIG = {
      dashboard: { panel: "Dashboard", any: true },

      tmEdit: { panel: "CRM", child: "Trucking & Material", includes: "Edit" },
      tmView: { panel: "CRM", child: "Trucking & Material", includes: "View" },
      tmInternalApproval: { panel: "CRM", child: "Trucking & Material", includes: "Internal Approval" },
      ownerOperator: { panel: "CRM", child: "Owner Operator", any: true },

      cd: { panel: "Databases", child: "Customer Database", any: true },
      ood: { panel: "Databases", child: "Owner Operator Database", any: true },
      cdd: { panel: "Databases", child: "CDL Driver Database", any: true },
      qd: { panel: "Databases", child: "Quarry Database", any: true },
      md: { panel: "Databases", child: "Material Database", any: true },
      jd: { panel: "Databases", child: "Job Database", any: true },

      tuEdit: { panel: "Finance", child: "Ticket Upload", includes: "Edit" },
      tuReview: { panel: "Finance", child: "Ticket Upload", includes: "Review" },
      tpDataInput: { panel: "Finance", child: "Ticket Processing", includes: "Data Input" },
      tpManagerReview: { panel: "Finance", child: "Ticket Processing", includes: "Manager Review" },
      tpArchiveView: { panel: "Finance", child: "Ticket Processing", includesAny: ["Archive View", "Archived View"] },
      tpArchiveEdit: { panel: "Finance", child: "Ticket Processing", includesAny: ["Archive Edit", "Archived Edit"] },
      imView: { panel: "Finance", child: "Invoice Management", includes: "View" },
      imEdit: { panel: "Finance", child: "Invoice Management", includes: "Edit" },
      lmView: { panel: "Finance", child: "Lien Process", includes: "View" },
      lmEdit: { panel: "Finance", child: "Lien Process", includes: "Edit" },
      paView: { panel: "Finance", child: "Project Analysis", includes: "View" },
      paEdit: { panel: "Finance", child: "Project Analysis", includes: "Edit" },

      btc: { panel: "Settings", child: "Bid Tool Configuration", any: true },
      re: { panel: "Settings", child: "Rule Engine", any: true },
      mr: { panel: "Settings", child: "Manage Roles", any: true },
      su: { panel: "Settings", child: "System Users", any: true },
      sp: { panel: "Settings", child: "Sales People", any: true },
      ss: { panel: "Settings", child: "System Settings", any: true },
      rd: { panel: "Settings", child: "Restore Data", any: true },
      id: { panel: "Settings", child: "Image Database", any: true },
      documents: { panel: "Settings", child: "Documents", any: true },
    };

    return Object.fromEntries(
      Object.entries(CONFIG).map(([key, rule]) => {
        const node = rule.child ? child(rule.panel, rule.child) : byTitle(rule.panel);
        let value = false;
        if (node) {
          if (rule.any) value = hasAny(node);
          else if (rule.includes) value = has(node, rule.includes);
          else if (rule.includesAny) value = hasAnyOf(node, rule.includesAny);
        }
        return [key, Boolean(value)];
      })
    );
  }

  handleToOpenRolesEdit = (record) => {
    let defaultPannelsOpen = [];
    record["otherData"] &&
      record["otherData"].map((p) => {
        if ("multiPannel" in p === true) {
          p.multiPannel
            .filter(
              (selectedPannel) => selectedPannel.selectedOptions.length > 0
            )
            .map((open) => defaultPannelsOpen.push(open.key));
        }
        return true;
      });

    const currentPermissions = this.buildPermissions(record["otherData"]);

    this.setState({
      isModalVisible: true,
      leadsData: record,
      PanelData: record["otherData"],
      SelectedPermissions: currentPermissions,
      isEditModalVisible: true,
      defaultPannelsOpen,
    });
    
    this.navigateToForm({
      isEdit: true,
      SelectedPermissions: currentPermissions,
      PanelData: record["other"],
      roleName: record?.roleName,
      roleId: record?.id,
    });

  };

  onClickReturn = () => {
    this.setState({
      isModalVisible: !this.state.isModalVisible,
      isEditModalVisible: !this.state.isEditModalVisible,
      leadsData: "",
      PanelData: [],
      defaultPannelsOpen: [],
    });
  };

  deleteUserRole = (id) => {
    this.props?.actionsFetchDeleteRole(id);
  };

  handleTableChage = (props) => {
    const tableSizeRange = JSON.parse(localStorage.getItem("tableSizeRange"));
    localStorage.setItem(
      "tableSizeRange",
      JSON.stringify({ ...tableSizeRange, manageRoles: props })
    );
  };

  render() {
    const {
      totalRolesData,
      isModalVisible,
      leadsData,
      filterData,
      SelectedPermissions,
      isEditModalVisible,
      PanelData,
    } = this.state;

    const { errorLoading, loading } = this.props;

    const columns = [
      {
        title: "ROLE NAME",
        dataIndex: "roleName",
        key: "roleName",
        sorter: false,
        with: "180px",

        render: (roleName) => {
          return (
            <span
              style={{
                textTransform: "capitalize",
              }}
            >
              {roleName}
            </span>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        key: "",
        sorter: false,
        render: (action, record) => {
          return (
            <>
              <Col
                style={{
                  width: "10px",
                  float: "right",
                  marginRight: "50px",
                }}
              >
                {action.roleName !== "Admin" && (
                  <Popover
                    content={
                      <Row className="popovergrid" style={{ maxWidth: "85px" }}>
                        {" "}
                        <Col
                          onClick={() => this.handleToOpenRolesEdit(record)}
                          span={24}
                          className="btn_edit"
                          style={{ cursor: "pointer" }}
                        >
                          <div className="icon-alignmentit span_edit">
                            <MdModeEditOutline /> Edit
                          </div>
                        </Col>
                        <Col span={24} style={{ cursor: "pointer" }}>
                          <Popconfirm
                            title="Are you sure？"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => this.deleteUserRole(record.id)}
                            className="btn_edit"
                          >
                            <div className="icon-alignmentit span_edit">
                              <MdDelete /> Delete
                            </div>
                          </Popconfirm>
                        </Col>
                      </Row>
                    }
                    trigger="hover"
                    placement="left"
                  >
                    <Button
                      type="button"
                      style={{ background: "transparent", border: "none" }}
                    >
                      <EllipsisOutlined
                        style={{ fontSize: "35px", color: "grey" }}
                        className="action-ellipsis-button"
                      />
                    </Button>
                  </Popover>
                )}
              </Col>
            </>
          );
        },
      },
    ];
    return (
      <div
        style={{
          background: "#fafafa",
        }}
      >
        <Loading enableLoading={loading} />

        <Row>
          <Col
            xxl={{ span: 24, offset: 0 }}
            xl={{ span: 24, offset: 0 }}
            lg={{ span: 24, offset: 0 }}
            md={{ span: 24, offset: 0 }}
            sm={{ span: 24, offset: 0 }}
            xs={{ span: 24, offset: 0 }}
          >
            <Row style={{ marginBottom: "1vw" }}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
                xl={{ span: 24 }}
                xxl={{ span: 24 }}
                // span={12}
              >
                <Row justify={"space-between"}>
                  <Col
                    xs={{ span: 16 }}
                    sm={{ span: 16 }}
                    md={{ span: 10 }}
                    lg={{ span: 10 }}
                    xl={{ span: 6 }}
                    xxl={{ span: 6 }}
                    // span={10}
                    className="quarrytoolgrid search-button-project"
                  >
                    <SearchFunction
                      data={totalRolesData}
                      getSearchData={this.searchResult}
                      //searchData={"roles"}
                      onResetData={this.onResetData}
                    />
                  </Col>
                  <Col
                    xs={{ span: 8 }}
                    sm={{ span: 8 }}
                    md={{ span: 8 }}
                    lg={{ span: 8 }}
                    xl={{ span: 8 }}
                    xxl={{ span: 8 }}
                  >
                    <Row style={{ justifyContent: "right" }}>
                      <Col className="gridbtntool">
                        <Button
                          type="primary"
                          icon={<PlusOutlined />}
                          onClick={this.showModal}
                          style={{
                            borderRadius: "5px",
                            height: "40px",
                          }}
                        >
                          <span
                            style={{ fontWeight: "500", fontSize: "16px" }}
                          >
                            Add Role
                          </span>
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
            {errorLoading ? (
              <ErrorView refreshRoles={this.onRefresh} type="ManageRoles" />
            ) : (
              <Card
                bodyStyle={{ textAlign: "left" }}
                className="manage-roles-card"
              >
                <Col
                  xxl={{ span: 24, offset: 0 }}
                  xl={{ span: 24, offset: 0 }}
                  lg={{ span: 24, offset: 0 }}
                  md={{ span: 24, offset: 0 }}
                  sm={{ span: 24, offset: 0 }}
                  xs={{ span: 24, offset: 0 }}
                  // span={24}
                  // offset={0}
                  data-aos="fade-up"
                >
                  <BaseTable
                    className="table_manageroles"
                    columnsData={columns}
                    source={filterData}
                    total={filterData.length}
                    handleTableChage={this.handleTableChage}
                    sizeRange={
                      window.screen.width > 1023
                        ? JSON.parse(localStorage.getItem("tableSizeRange"))
                            ?.manageRoles
                        : filterData.length
                    }
                    pagination={window.screen.width > 1023 ? true : false}
                  />
                </Col>
              </Card>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) =>
  // console.log(state),
  ({
    rolesResult: state?.reducer?.rolesResult,
    loading: state?.reducer?.rolesResult?.loading,
    errorLoading: state?.reducer?.rolesResult?.error,
    rolesInfo: state?.reducer?.rolesInfo,
    rolesUpdateInfo: state?.reducer?.rolesUpdateInfo,
  });

const mapDispatchToProps = (dispatch) => ({
  actionsFetchGetRoles: () => {
    dispatch(getRoles());
  },
  actionsFetchAddRole: (data) => {
    dispatch(addRole(data));
  },
  actionsFetchUpdateRole: (id, data) => {
    dispatch(updateRole(id, data));
  },
  actionsFetchDeleteRole: (id) => {
    dispatch(deleteRole(id));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAppContext(withRouter(ManageRoles)));
